<template>
    <div>
        <h1>Page not found</h1>
        <router-view/> <!-- Optional -->
    </div>
</template>

<script>
    export default {
        name: 'error'
    }
</script>



// WEBPACK FOOTER //
// src/layouts/Error.vue